import { makeAutoObservable } from 'mobx';
import { ICredentialsStore } from '../../integration-store';
import { IWebshipperCredentialsModel } from '../../../../../../models/IntegrationsTypes';

class WebshipperCredentialsStore implements ICredentialsStore {
    private _changes: IWebshipperCredentialsModel = {} as IWebshipperCredentialsModel;

    constructor() {
        makeAutoObservable(this, {}, { autoBind: true });
    }
    public get username() { return this._changes.username; };
    public get orderChannelId() { return this._changes.order_channel_id; };
    public get internalName() { return this._changes.internal_name; };
    public get apiKey() { return this._changes.api_key; };

    setInternalName(value: string) {
        this._changes.internal_name = value;
    };
    
    setApiKey(value: string) {
        this._changes.api_key = value;
    };

    setOrderChannelId(value: string) {
        this._changes.order_channel_id = value;
    };

    setUsername(value: string) {
        this._changes.username = value;
    };

    /** ICredentialsStore implementation ************/
    public async getCredentials() {
        return { ...this._changes };
    }
}

export default WebshipperCredentialsStore;
